// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"203":"6b9e479b","213":"50e5f0f3","944":"a12fe585"}[chunkId] + ".chunk.css";
};